
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetInstitutionsByTrialId, GetInstitutionsByTrialIdResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetInstitutionsByTrialIdResponse, GetInstitutionsByTrialIdResponse>) => response?.data?.institutions;
const getError = (response?: SWRResponse<GetInstitutionsByTrialIdResponse, GetInstitutionsByTrialIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetInstitutionsByTrialIdResponse, GetInstitutionsByTrialIdResponse>) => ({});

const useGetTrialInstitutions = (query?: Partial<GetInstitutionsByTrialId>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetInstitutionsByTrialId(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialInstitutions;